// ToggleField.tsx — accessible on/off switch (≥44px touch target).
export interface ToggleFieldProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  hint?: string | undefined;
  disabled?: boolean | undefined;
}

export function ToggleField({ label, checked, onChange, hint, disabled }: ToggleFieldProps) {
  return (
    <div class="field">
      <div class="toggle-row">
        <span class="field-label" style={{ marginBottom: 0 }}>
          {label}
        </span>
        <button
          type="button"
          class="switch"
          role="switch"
          aria-checked={checked}
          aria-label={label}
          disabled={disabled}
          onClick={() => onChange(!checked)}
        >
          <span class="track">
            <span class="knob" />
          </span>
        </button>
      </div>
      {hint ? <div class="field-hint">{hint}</div> : null}
    </div>
  );
}
